var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatCuentasYPagos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_cuentas-y-pagos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13",
    "data-name": "Rect\\xE1ngulo 13",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-credit-card-14",
    d: "M151.157,2H54.966A13.747,13.747,0,0,0,41.225,15.742V43.225H151.157V67.272a3.437,3.437,0,0,1-3.435,3.435H137.416V84.449h13.742A13.747,13.747,0,0,0,164.9,70.708V15.742A13.747,13.747,0,0,0,151.157,2Zm0,20.612H54.966V19.177A3.437,3.437,0,0,1,58.4,15.742h89.32a3.437,3.437,0,0,1,3.435,3.435ZM109.933,56.966H13.742A13.747,13.747,0,0,0,0,70.708v54.966a13.747,13.747,0,0,0,13.742,13.742h96.191a13.747,13.747,0,0,0,13.742-13.742V70.708A13.747,13.747,0,0,0,109.933,56.966ZM34.354,125.674H20.612V118.8H34.354Zm20.612,0H41.225V118.8H54.966Zm2.2-23.2a17.177,17.177,0,1,1,0-29.173,21.011,21.011,0,0,0,0,29.173Zm25.284,23.2H68.708V118.8H82.449Zm-6.871-20.612A17.177,17.177,0,1,1,92.756,87.884,17.174,17.174,0,0,1,75.579,105.061Zm27.483,20.612H89.32V118.8h13.742Z",
    transform: "translate(18 29)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatCuentasYPagos);
export default __webpack_public_path__ + "static/media/cat_cuentas-y-pagos.b2c196bc962835cb96a86ecf4b61dd3d.svg";
export { ForwardRef as ReactComponent };